<template>
  <div
      :class="['box', positionClass, heightClass, { show: isVisible }]"
      ref="boxRef"
      style="min-height: 200px;"
  >
    <div :class="['blue-container', containerClass]">
      <div class="container-content">
        <div class="container-content__title">
          {{ title }}
        </div>
        <div v-if="description" :class="['container-content__description', descriptionClass]">
          {{ description }}
        </div>
        <div v-if="descriptionLines" :class="['container-content__description', descriptionClass]">
          <p v-for="(line, index) in descriptionLines" :key="index">{{ line }}</p>
        </div>
        <div v-if="pdfLink" class="container-content__pdfs" :class="pdfsClass">
          <a :href="pdfLink" target="_blank" class="btn">
            {{ pdfLabel }}
          </a>
          <a v-if="pdfLink2" :href="pdfLink2" target="_blank" class="btn">
            {{ pdfLabel + ' 2'}}
          </a>
        </div>
      </div>
      <img :src="imageSrc" alt="" :class="['box-img', imageClass]" loading="lazy"/>
    </div>
  </div>
</template>
<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue'
// eslint-disable-next-line
const props = defineProps({
  position: {type: String, default: 'right'}, // 'left' or 'right'
  title: {type: String, required: true},
  description: {type: String, default: ''},
  descriptionLines: { type: Array, default: () => [] },
  pdfLink: {type: String, required: false},
  pdfLink2: {type: String, required: false},
  pdfLabel: {type: String, default: 'PDF'},
  imageSrc: {type: String, required: true},
  heightClass: {type: String, default: ''}
})

const positionClass = `box__${props.position}`
const containerClass = `blue-container__${props.position}`
const descriptionClass = `container-content__description-${props.position}`
const pdfsClass = `container-content__pdfs-${props.position}`
const imageClass = `box-img--${props.position}`

const isVisible = ref(false)
const boxRef = ref(null)
let observer = null
onMounted(() => {
  observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          isVisible.value = true
          observer.disconnect()
        }
      },
      {
        root: null,
        threshold: 0
      }
  )

  if (boxRef.value) {
    observer.observe(boxRef.value)
  }
})

onBeforeUnmount(() => {
  if (observer) observer.disconnect()
})
</script>

<style scoped>

</style>
